import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { ClipboardFeedbackService } from 'src/app/services/clipboard-feedback.service';
import { TranslateConfigService } from 'src/app/services/translate-config.service';
import { LongPressDirective } from 'src/app/shared/directives/long-press.directive';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, LongPressDirective]
})
export class MessagesComponent  implements OnInit {
  @Input() message:any
  @Output() showImage: EventEmitter<string> = new EventEmitter<string>();
  constructor(
    private clipboardFeedbackService: ClipboardFeedbackService,
    public t: TranslateConfigService,
  ) { }

  ngOnInit() {}

  imageUrl = '../../../../assets/images/agent.png'

  onImageClick(url: string) {
    if (!url) return;
    this.showImage.emit(url);
  }

  async copyMessage(): Promise<void> {
    await this.clipboardFeedbackService.copyText(
      this.message?.text ?? '',
      this.t.getItemTranslated('TEXT_COPIED') || 'Texto copiado al portapapeles',
      this.t.getItemTranslated('COMMON.UNEXPECTED_ERROR') || 'An unexpected error has occurred',
    );
  }
}
